"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("react-datetime/css/react-datetime.css");
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDatetime2 = _interopRequireDefault(require("react-datetime"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _CalendarToday = _interopRequireDefault(require("@mui/icons-material/CalendarToday"));
var _CodeConsts = require("../../constants/CodeConsts");
var _labelConsts = require("../../constants/labelConsts");
var _CodeUtil = require("../system/CodeUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StyledIconButton = (0, _styles.styled)(_Button.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    padding: 0,
    minWidth: 'initial'
  };
});
const StyledCalendarIcon = (0, _styles.styled)(_CalendarToday.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    color: theme.palette.icon && theme.palette.icon.secondary
  };
});
const StyledHelperText = (0, _styles.styled)(_FormHelperText.default)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    marginRight: -300,
    width: 'calc(100%)'
  };
});
const StyledSelect = (0, _styles.styled)(_Select.default, {
  shouldForwardProp: prop => prop !== '$noneSelected'
})(_ref4 => {
  let {
    theme,
    $noneSelected
  } = _ref4;
  return _objectSpread({}, !!$noneSelected && {
    color: theme.palette.select && theme.palette.select.noneSelected
  });
});
const NO_SELECT = 'none';
const INVALID = 'invalid';
const DEFAULT_HOUR = '00';
const DEFAULT_MINUTE = '00';

/**
 * 日付、日時部品
 * @param {string} value - 選択値
 * @param {func} onChange - 変更時のハンドラ
 * @param {bool} [dateOnly] - 日付のみ選択時true
 * @param {bool} [required] - 必須項目とする場合True
 * @param {string} [name] - コンポーネント名（日付、日時選択部品を同一コンポーネントで複数マウントする場合の識別子として利用するため、複数マウント時は必須）
 * @param {ref} [dtRef] - Ref
 * @param {string} [defaultHour] - 年月日を選択したときに選択する「時」の値
 * @param {string} [defaultMinute] - 年月日を選択したときに選択する「分」の値
 */
class InputDateTime extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "INIT_STATE", {
      year: NO_SELECT,
      month: NO_SELECT,
      day: NO_SELECT,
      hour: NO_SELECT,
      minute: NO_SELECT,
      dialogOpen: false,
      calendarView: null,
      defaultHour: this.props.defaultHour ? this.props.defaultHour : DEFAULT_HOUR,
      defaultMinute: this.props.defaultMinute ? this.props.defaultMinute : DEFAULT_MINUTE
    });
    _defineProperty(this, "zeroPadding", target => {
      return ('0' + target).slice(-2);
    });
    _defineProperty(this, "isNone", value => {
      return NO_SELECT === value;
    });
    _defineProperty(this, "parseMoment", target => {
      let {
        year,
        month,
        day,
        hour,
        minute
      } = this.state;
      const m = (0, _moment.default)(target, ['YYYY/MM/DD HH:mm', 'YYYY/MM/DD']);
      if (m.isValid()) {
        year = m.year();
        // 月はゼロ埋め無し（'1'〜'12'）で内部保持
        month = String(m.month() + 1);
        day = this.zeroPadding(m.date());
        hour = this.zeroPadding(m.hour());
        minute = this.zeroPadding(m.minute());
      }
      if (this.props.dateOnly) {
        hour = '00';
        minute = '00';
      }
      return {
        year,
        month,
        day,
        hour,
        minute
      };
    });
    _defineProperty(this, "buildMomentFrom", _ref5 => {
      let {
        year,
        month,
        day
      } = _ref5;
      if (!this.isNone(year) && !this.isNone(month) && !this.isNone(day)) {
        return (0, _moment.default)({
          year: Number(year),
          month: Number(month) - 1,
          day: Number(day)
        });
      }
      return null;
    });
    _defineProperty(this, "handleChange", event => {
      const {
        defaultHour,
        defaultMinute
      } = this.state;
      let {
        year,
        month,
        day,
        hour,
        minute
      } = _objectSpread(_objectSpread({}, this.state), {}, {
        [event.target.name]: event.target.value
      });
      let newState = {
        [event.target.name]: event.target.value
      };
      if (!this.props.dateOnly &&
      // 日付入力でなく、日時入力であること
      ['year', 'month', 'day'].includes(event.target.name) &&
      // イベントをトリガーしたセレクトボックスが年月日のいずれかであること
      !this.isNone(year) &&
      // 年が選択済であること
      !this.isNone(month) &&
      // 月が選択済であること
      !this.isNone(day) &&
      // 日が選択済であること
      this.isNone(hour) &&
      // 時が未選択であること
      this.isNone(minute) // 分が未選択であること
      ) {
        // パラメータで指定された時分をセット
        newState.hour = defaultHour;
        newState.minute = defaultMinute;
      }

      // 表示中のカレンダーも選択した年月に同期
      if (['year', 'month', 'day'].includes(event.target.name)) {
        const nextYear = event.target.name === 'year' ? event.target.value : year;
        const nextMonth = event.target.name === 'month' ? event.target.value : month;
        const nextDay = event.target.name === 'day' ? event.target.value : day;
        if (!this.isNone(nextYear) && !this.isNone(nextMonth) && !this.isNone(nextDay)) {
          newState.calendarView = (0, _moment.default)({
            year: Number(nextYear),
            month: Number(nextMonth) - 1,
            day: Number(nextDay)
          });
        }
      }
      this.setState(newState, this.onChange);
      if (event.target.name === 'year' && event.target.value === NO_SELECT) {
        this.handleChange({
          target: {
            name: 'month',
            value: NO_SELECT
          }
        });
      }
      if (event.target.name === 'month' && event.target.value === NO_SELECT) {
        this.handleChange({
          target: {
            name: 'day',
            value: NO_SELECT
          }
        });
      }
      if (event.target.name === 'day' && event.target.value === NO_SELECT) {
        if (!this.props.dateOnly) {
          this.handleChange({
            target: {
              name: 'hour',
              value: NO_SELECT
            }
          });
        }
      }
      if (event.target.name === 'hour' && event.target.value === NO_SELECT) {
        if (!this.props.dateOnly) {
          this.handleChange({
            target: {
              name: 'minute',
              value: NO_SELECT
            }
          });
        }
      }
    });
    _defineProperty(this, "onChange", () => {
      const {
        year,
        month,
        day,
        hour,
        minute
      } = this.state;
      if (this.isAllEmpty()) {
        // 全てが空の状態
        this.props.onChange('');
        return;
      }
      if (this.isAnyEmpty()) {
        // いずれかが空の場合、エラー状態とする
        this.props.onChange(INVALID);
        return;
      }
      let retVal = '';
      let format = 'YYYY/MM/DD HH:mm';
      if (this.props.dateOnly) {
        format = 'YYYY/MM/DD';
      }
      const dt = (0, _moment.default)({
        year,
        month: Number(month) - 1,
        day,
        hour,
        minute
      });
      if (dt.isValid()) {
        retVal = dt.format(format);
      } else {
        retVal = INVALID;
      }
      this.props.onChange(retVal);
    });
    _defineProperty(this, "isAllEmpty", () => {
      const {
        year,
        month,
        day,
        hour,
        minute
      } = this.state;
      if (this.props.dateOnly) {
        if (this.isNone(year) && this.isNone(month) && this.isNone(day)) {
          return true;
        }
      } else {
        if (this.isNone(year) && this.isNone(month) && this.isNone(day) && this.isNone(hour) && this.isNone(minute)) {
          return true;
        }
      }
      return false;
    });
    _defineProperty(this, "isAnyEmpty", () => {
      const {
        year,
        month,
        day,
        hour,
        minute
      } = this.state;
      if (this.props.dateOnly) {
        if (this.isNone(year) || this.isNone(month) || this.isNone(day)) {
          return true;
        }
      } else {
        if (this.isNone(year) || this.isNone(month) || this.isNone(day) || this.isNone(hour) || this.isNone(minute)) {
          return true;
        }
      }
      return false;
    });
    _defineProperty(this, "chgNavi", type => {
      // カレンダー表示モード変更時、日付表示モードのときのみ、年月の表示を書き換える
      if (type === 'days') {
        setTimeout(this.convMonth, 10);
      }
    });
    _defineProperty(this, "moveNavi", (amount, type) => {
      // 次へ、前へ移動時、年月切り替え時のみ、年月の表示を書き換える
      this.setState(s => ({
        calendarView: (s.calendarView || (0, _moment.default)()).clone().add(amount, type)
      }), () => setTimeout(this.convMonth, 10));
    });
    _defineProperty(this, "renderValue", (placeholder, format) => value => {
      if (value === NO_SELECT) {
        return placeholder;
      }
      return format ? this.momentFormat(value, format) : value;
    });
    _defineProperty(this, "momentFormat", (value, format) => {
      switch (format) {
        case 'MMM':
          return (0, _moment.default)().month(value - 1).locale(this.props.language).format(format);
        default:
          return (0, _moment.default)(value).locale(this.props.language).format(format);
      }
    });
    /**
     * カレンダー上部の「月＋年」表示を、「年＋月」表示とする（日本語専用）
     */
    _defineProperty(this, "convMonth", () => {
      let obj = document.querySelector('.rdtPicker thead .rdtSwitch') || document.getElementsByClassName('rdtSwitch')[0];
      if (obj) {
        let text = (obj.textContent || obj.innerHTML).trim();
        if (/^\d{4}年\s+.+$/.test(text)) return;
        let m = text.match(/^(.+)\s+(\d{4})$/);
        if (m) {
          obj.textContent = m[2] + '年 ' + m[1];
        }
      }
    });
    _defineProperty(this, "validYear", current => {
      return this.yearList.includes(current.format('YYYY'));
    });
    _defineProperty(this, "getCalendarView", () => {
      const {
        calendarView
      } = this.state;
      if (calendarView && _moment.default.isMoment(calendarView)) return calendarView;
      const fromSelection = this.buildMomentFrom(this.state);
      if (fromSelection) return fromSelection;
      const fromProp = (0, _moment.default)(this.props.value, ['YYYY/MM/DD HH:mm', 'YYYY/MM/DD']);
      return fromProp.isValid() ? fromProp : (0, _moment.default)();
    });
    _defineProperty(this, "getOpenInitialView", () => {
      const selection = this.buildMomentFrom(this.state);
      if (selection) return selection;
      const fromProp = (0, _moment.default)(this.props.value, ['YYYY/MM/DD HH:mm', 'YYYY/MM/DD']);
      return fromProp.isValid() ? fromProp : (0, _moment.default)();
    });
    this.state = _objectSpread({}, this.INIT_STATE);
    let monthItems = this.props.getCodeItems(_CodeConsts.CODE.MONTHS.KBN);
    // カレンダーの月表示用データを上書き
    _moment.default.updateLocale('ja', {
      months: monthItems.map(item => item.displayName + '月')
    });
    this.yearList = [];
    let _year = (0, _moment.default)().format('YYYY');
    _year = Number(_year);
    // 現在年から前後３年ずつを選択肢とする
    for (let i = -3; _year + i < _year + 4; i++) {
      this.yearList.push(String(_year + i));
    }

    // メニューの月はゼロ埋め無しの値（'1'〜'12'）に正規化
    this.monthList = monthItems.map(item => _objectSpread(_objectSpread({}, item), {}, {
      value: String(parseInt(item.value, 10))
    }));
    this.dayList = Array.from(new Array(31)).map((v, i) => {
      return this.zeroPadding(i + 1);
    });
    this.hourList = Array.from(new Array(24)).map((v, i) => {
      return this.zeroPadding(i);
    });
    this.minuteList = Array.from(new Array(60)).map((v, i) => {
      return this.zeroPadding(i);
    });
    this.input = /*#__PURE__*/(0, _react.createRef)();
  }
  componentDidMount() {
    const parseObj = this.parseMoment(this.props.value);
    const initialView = this.buildMomentFrom(parseObj) || (0, _moment.default)(this.props.value, ['YYYY/MM/DD HH:mm', 'YYYY/MM/DD']);
    this.setState(_objectSpread(_objectSpread({}, parseObj), {}, {
      calendarView: initialView && initialView.isValid() ? initialView : (0, _moment.default)()
    }));
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      if (prevProps.value && !this.props.value) {
        this.setState({
          year: NO_SELECT,
          month: NO_SELECT,
          day: NO_SELECT,
          hour: this.props.dateOnly ? '00' : NO_SELECT,
          minute: this.props.dateOnly ? '00' : NO_SELECT,
          calendarView: (0, _moment.default)()
        });
        return;
      }
      const parseObj = this.parseMoment(this.props.value);
      const view = this.buildMomentFrom(parseObj) || (0, _moment.default)(this.props.value, ['YYYY/MM/DD HH:mm', 'YYYY/MM/DD']);
      this.setState(_objectSpread(_objectSpread({}, parseObj), {}, {
        calendarView: view && view.isValid() ? view : (0, _moment.default)()
      }));
    }
  }
  render() {
    const {
      className,
      intl,
      language,
      dateOnly,
      value,
      error,
      helperText,
      dtRef
    } = this.props;
    const calendarProp = {};
    if (_CodeConsts.CODE.LOCALE.CODE_JA === language) {
      calendarProp.onViewModeChange = this.chgNavi;
      calendarProp.onNavigateBack = (amount, type) => this.moveNavi(-amount, type);
      calendarProp.onNavigateForward = (amount, type) => this.moveNavi(amount, type);
    }
    const hasError = !!error;
    const calendarValue = this.getCalendarView();
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      defaultValue: value
    }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      columnSpacing: 1,
      rowSpacing: 0,
      component: "div",
      alignItems: "center",
      className: className,
      wrap: "nowrap",
      ref: dtRef
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(StyledSelect, {
      value: this.state.year,
      displayEmpty: true,
      renderValue: this.renderValue(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_YEAR
      })),
      $noneSelected: this.state.year === NO_SELECT,
      name: 'year',
      onChange: this.handleChange,
      variant: "outlined",
      error: hasError
    }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: NO_SELECT
    }, "\xA0"), this.yearList.map(item => {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: item,
        value: item
      }, item);
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "/")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, null, /*#__PURE__*/_react.default.createElement(StyledSelect, {
      $noneSelected: this.state.month === NO_SELECT,
      value: this.state.month,
      onChange: this.handleChange,
      name: "month",
      renderValue: value => {
        const formatVal = value === NO_SELECT ? NO_SELECT : this.zeroPadding(value);
        if (_CodeConsts.CODE.LOCALE.CODE_JA === language) {
          return this.renderValue(intl.formatMessage({
            id: _labelConsts.LABEL.CORE_MONTH
          }))(formatVal);
        } else {
          return this.renderValue(intl.formatMessage({
            id: _labelConsts.LABEL.CORE_MONTH
          }), 'MMM')(formatVal);
        }
      },
      error: hasError
    }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: NO_SELECT
    }, "\xA0"), this.monthList.map(item => {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: item.value,
        value: item.value
      }, item.displayName);
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "/")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, null, /*#__PURE__*/_react.default.createElement(StyledSelect, {
      $noneSelected: this.state.day === NO_SELECT,
      value: this.state.day,
      onChange: this.handleChange,
      name: "day",
      renderValue: this.renderValue(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_DAY
      })),
      error: hasError
    }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: NO_SELECT
    }, "\xA0"), this.dayList.map(item => {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: item,
        value: item
      }, item);
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(StyledIconButton, {
      variant: "text",
      onClick: () => {
        this.setState({
          dialogOpen: true,
          calendarView: this.getOpenInitialView()
        });
      }
    }, /*#__PURE__*/_react.default.createElement(StyledCalendarIcon, null)), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
      open: this.state.dialogOpen,
      onClose: () => {
        this.setState({
          dialogOpen: false
        });
      },
      TransitionProps: _CodeConsts.CODE.LOCALE.CODE_JA === language ? {
        onEntered: () => {
          this.convMonth();
        }
      } : undefined
    }, this.state.dialogOpen && /*#__PURE__*/_react.default.createElement(_reactDatetime2.default, _extends({
      defaultValue: this.getOpenInitialView(),
      value: calendarValue,
      input: false,
      dateFormat: true,
      timeFormat: false,
      locale: language,
      onChange: value => {
        // カレンダー選択時、時分が未入力ならば自動入力
        const {
          defaultHour,
          defaultMinute
        } = this.state;
        let {
          hour,
          minute
        } = this.state;
        if (!this.props.dateOnly && this.isNone(hour) && this.isNone(minute)) {
          hour = defaultHour;
          minute = defaultMinute;
        }
        this.setState({
          dialogOpen: false,
          year: value.format('YYYY'),
          // 月はゼロ埋め無しで内部保持
          month: value.format('M'),
          day: value.format('DD'),
          hour: hour,
          minute: minute,
          calendarView: value.clone()
        }, this.onChange);
      },
      isValidDate: this.validYear
    }, calendarProp)))), !dateOnly && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, null, /*#__PURE__*/_react.default.createElement(StyledSelect, {
      $noneSelected: this.state.hour === NO_SELECT,
      value: this.state.hour,
      onChange: this.handleChange,
      name: "hour",
      renderValue: this.renderValue(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_HOUR
      })),
      error: hasError
    }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: NO_SELECT
    }, "\xA0"), this.hourList.map(item => {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: item,
        value: item
      }, item);
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, ":")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, null, /*#__PURE__*/_react.default.createElement(StyledSelect, {
      $noneSelected: this.state.minute === NO_SELECT,
      value: this.state.minute,
      onChange: this.handleChange,
      name: "minute",
      renderValue: this.renderValue(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_MINUTE
      })),
      error: hasError
    }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: NO_SELECT
    }, "\xA0"), this.minuteList.map(item => {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: item,
        value: item
      }, item);
    })))))), hasError && /*#__PURE__*/_react.default.createElement(StyledHelperText, {
      error: hasError
    }, helperText));
  }
}
InputDateTime.propTypes = {
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  dateOnly: _propTypes.default.bool,
  defaultHour: _propTypes.default.string,
  defaultMinute: _propTypes.default.string,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.node,
  dtRef: _propTypes.default.any,
  name: _propTypes.default.string
};
const mapStateToProps = state => {
  return {
    language: state.coreLocale.language
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)(InputDateTime)));